import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import ProductList from "../components/products/productList/productList";
import InventoryAdjustmentHistory from "../components/products/productList/addEditProduct/inventoryAdjustmentHistory";
import BulkEdit from "../components/products/productList/bulkEdit";
import ReadymadeProducts from "../components/products/productList/readymateProducts/readymadeProducts";
import AddProduct from "../components/products/productList/addEditProduct/addEditProduct";
import { forSlideFromLeftAnimation } from "../shared/hooks/funcions";

// custom imports
/* 
  Functional component to hold all the pages in a stack navigator
 */
const ProductStack = () => {
    // Variable to handle appStack
    const AppStack = createStackNavigator();

    return (
        <AppStack.Navigator
            initialRouteName={"ProductList"}
            screenOptions={{ headerShown: false, cardStyleInterpolator: forSlideFromLeftAnimation }}>
            <AppStack.Screen name="ProductList" component={ProductList} />
            <AppStack.Screen name="AddEditProduct" component={AddProduct} />
            <AppStack.Screen name="InventoryAdjustmentHistory" component={InventoryAdjustmentHistory} />
            <AppStack.Screen name="BulkEdit" component={BulkEdit} />
            <AppStack.Screen name="ReadymadeProducts" component={ReadymadeProducts} />
        </AppStack.Navigator>
    );
};

export default ProductStack;